import { AnalyticsEvent } from '../models';

export class BagOffersModalViewEvent implements AnalyticsEvent {
  name = 'BagOffersModalViewEvent';
}
